<template>
  <div class="automate allot-rule">
    <div class="head-box">
      <h4 class="c-flex c-flex-item">
        调度策略
        <el-popover
          placement="right"
          trigger="hover"
          content="设置调度策略，匹配策略的工单将自动分给对应的服务资源"
        >
          <i class="el-icon-info f-s-12 c_gray c-m-l-10" slot="reference"></i>
        </el-popover>
      </h4>
      <div class="c-flex c-flex-item">
        <el-input
          placeholder="请输入策略名称"
          v-model="searchValue"
          clearable
          @clear="
            fpi.page = 1;
            getData();
          "
          @keyup.enter.native="
            fpi.page = 1;
            getData();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click.native="
              fpi.page = 1;
              getData();
            "
          ></el-button>
        </el-input>
        <el-button type="primary" class="m-l-10" @click="doNew">新增调度策略</el-button>
        <el-button
          v-if="osg.has('Scheduler,partsPriority')"
          type="primary"
          class="m-l-10"
          @click="partsPriorityClick"
        >
          设置多部位调度优先级
        </el-button>
        <el-popover width="200" popper-class="c-popper" @show="osg.colSetShow">
          <div
            v-if="osg.customize.entity.entityID == osg.customize.entity.tenantId"
            style="border-bottom: 1px solid #DCDFE6;margin-bottom: 12px;"
          >
            <div>
              <i class="el-icon-s-tools c-m-r-5"></i>
              <span>应用范围：</span>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-model="osg.customize.bizType"
                @change="osg.customizeBizTypeChange"
                placeholder="请选择 个人/组织/角色"
                size="small"
                style="width:100%"
              >
                <el-option
                  v-for="item in osg.options.bizType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-if="osg.customize.bizType == 0"
                v-model="osg.customize.bizId"
                :remote-method="osg.getUsers"
                filterable
                remote
                placeholder="可搜索人员姓名/手机/组织"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.users"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
              <el-cascader
                v-if="osg.customize.bizType == 1"
                v-model="osg.customize.bizId"
                :options="osg.options.orgs"
                :props="{
                  checkStrictly: true,
                  emitPath: false,
                  label: 'orgName',
                  value: '_id',
                  children: 'orgList'
                }"
                size="small"
                style="width:100%"
                placeholder="请选择组织"
              ></el-cascader>
              <el-select
                v-if="osg.customize.bizType == 2"
                v-model="osg.customize.bizId"
                placeholder="请选择角色"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.roles"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="c-popper-header">
            <i class="el-icon-info c-blue c-m-r-5"></i>
            <span>拖拽字段进行排序</span>
          </div>
          <div class="c-popper-content">
            <draggable v-model="extFields" @end="osg.listRefresh">
              <transition-group>
                <template v-for="(f, i) in extFields">
                  <div
                    v-if="f.showList && f.showList.indexOf('1') != -1"
                    :key="i"
                    class="c-popper-row"
                  >
                    <el-switch
                      v-model="f.customizeFlag"
                      :active-value="1"
                      :inactive-value="0"
                      @change="osg.listRefresh"
                    ></el-switch>
                    <span>{{ f.nameDisp }}</span>
                  </div>
                </template>
              </transition-group>
            </draggable>
          </div>
          <div class="c-popper-footer">
            <el-button type="primary" size="mini" @click="osg.saveConfig()">保存</el-button>
            <el-button type="text" size="mini" @click="osg.listReset">重置</el-button>
          </div>
          <i slot="reference" class="el-icon-s-operation c_size_20 c-blue c-m-l-10 c-pointer"></i>
        </el-popover>
      </div>
    </div>
    <div class="content-box">
      <div class="content-filter">
        <c-filter></c-filter>
      </div>
      <div class="content-table">
        <el-table ref="table" :data="fpi.data" empty-text="暂无数据" height="calc(100% - 50px)">
          <c-table :fields="extFields"></c-table>
          <el-table-column fixed="right" width="100px">
            <template slot-scope="scope">
              <el-dropdown>
                <el-button>
                  操作
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="doEdit(scope.row)">
                    编辑
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="scope.row.state == 0"
                    @click.native="doEnable(scope.row._id)"
                  >
                    启用
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="scope.row.state == 1"
                    @click.native="doDisable(scope.row._id)"
                  >
                    禁用
                  </el-dropdown-item>
                  <el-dropdown-item @click.native="doRemove(scope.row._id)">
                    删除
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="fpi.total"
        ></el-pagination>
      </div>
    </div>
    <el-dialog title="调度策略" :visible.sync="openDetail" width="700px">
      <c-form
        :formData="formData"
        :fields="extFields"
        :area="area"
        :upload="upload"
        :options="options"
        ref="form"
        labelWidth="150px"
        @changeForm="osg.changeForm"
      >
        <template slot="regions">
          <el-select
            v-model="formData.regions"
            placeholder="请选择"
            multiple
            @change="regionsChange()"
            clearable
          >
            <el-option
              v-for="item in options.regions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </template>
        <template slot="appointType">
          <el-select
            v-model="formData.appointType"
            placeholder="请选择"
            @change="appointTypeChange()"
            clearable
          >
            <el-option
              v-for="item in options.resourceType"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </template>
        <template slot="conditions">
          <el-form-item>
            <el-tag type="success" size="medium">多条件均满足时策略生效</el-tag>
          </el-form-item>
          <el-form-item v-for="(condition, index) of formData.conditions" :key="index">
            <div>条件{{ index + 1 }}</div>
            <div class="condition-card">
              <el-card shadow="hover">
                <el-form-item label="分单条件">
                  <el-select
                    v-model="formData.conditions[index].type"
                    placeholder="请选择"
                    @change="
                      formData.conditions[index].value = '';
                      getOptions(formData.conditions[index].type);
                    "
                    clearable
                  >
                    <el-option
                      v-for="item in options.allotType"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                      :disabled="
                        formData.conditions.some(
                          K =>
                            K.type == item.value ||
                            (item.value.endsWith('Inverse')
                              ? item.value.substring(0, item.value.length - 7) == K.type
                              : item.value + 'Inverse' == K.type)
                        )
                      "
                    ></el-option>
                  </el-select>
                </el-form-item>
                <!--按省市区-->
                <el-form-item
                  v-if="formData.conditions[index].type.startsWith('area')"
                  :label="'按' + osg.codelabel('allotType', formData.conditions[index].type)"
                  prop="area"
                >
                  <el-cascader
                    :props="area.props"
                    :options="area.options"
                    v-model="formData.conditions[index].value"
                    clearable
                  ></el-cascader>
                </el-form-item>
                <!--按服务区域-->
                <el-form-item
                  v-else-if="formData.conditions[index].type.startsWith('serviceTerritory')"
                  :label="'按' + osg.codelabel('allotType', formData.conditions[index].type)"
                >
                  <el-select
                    v-model="formData.conditions[index].value"
                    multiple
                    filterable
                    remote
                    reserve-keyword
                    placeholder="可搜索服务区域"
                    :remote-method="getST"
                    @change="$forceUpdate()"
                    clearable
                  >
                    <el-option
                      v-for="item in options.serviceTerritory"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <!--按渗漏部位-->
                <el-form-item
                  v-else-if="formData.conditions[index].type.startsWith('exts.leakagesite_copy')"
                  :label="'按' + osg.codelabel('allotType', formData.conditions[index].type)"
                >
                  <el-cascader
                    v-model="formData.conditions[index].value"
                    :options="options.repairParts"
                    :props="{ multiple: true, checkStrictly: true, label: 'name', emitPath: false }"
                    clearable
                  ></el-cascader>
                </el-form-item>
                <!--按信息渠道-->
                <el-form-item
                  v-else-if="formData.conditions[index].type.startsWith('channel')"
                  :label="'按' + osg.codelabel('allotType', formData.conditions[index].type)"
                >
                  <el-cascader
                    v-model="formData.conditions[index].value"
                    :options="options.channel"
                    :props="{ multiple: true, checkStrictly: true, label: 'name', emitPath: false }"
                    clearable
                  ></el-cascader>
                </el-form-item>
                <!--按其他 档案字段-->
                <el-form-item
                  v-else
                  :label="'按' + osg.codelabel('allotType', formData.conditions[index].type)"
                >
                  <el-select
                    v-model="formData.conditions[index].value"
                    multiple
                    clearable
                    filterable
                    allow-create
                    @change="
                      conditionValueChange(
                        formData.conditions[index].type,
                        formData.conditions[index].value
                      )
                    "
                  >
                    <el-option
                      v-for="item in options[formData.conditions[index].type]"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-card>
              <div class="card-remove">
                <i class="el-icon-remove" @click="removeCondition(index)"></i>
              </div>
            </div>
          </el-form-item>
          <el-form-item>
            <el-button plain icon="el-icon-plus" class="button_dashed" @click="newCondition">
              新增条件
            </el-button>
          </el-form-item>
        </template>
        <template slot="indexRules">
          <el-form-item>
            <el-tag type="success" size="medium">多条指标规则均满足时策略生效</el-tag>
          </el-form-item>
          <el-form-item v-for="(condition, index) of formData.indexRules" :key="index">
            <div>指标规则{{ index + 1 }}</div>
            <div class="condition-card">
              <el-card shadow="hover">
                <el-form-item label="指标">
                  <el-select
                    v-model="formData.indexRules[index].ruleId"
                    placeholder="请选择指标"
                    clearable
                  >
                    <el-option
                      v-for="item in options.scoreCalcRules"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                      :disabled="
                        formData.indexRules.find(indexRule => indexRule.ruleId == item.value)
                      "
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="规则条件">
                  <el-select
                    v-model="formData.indexRules[index].calcSymbol"
                    placeholder="请选择规则条件"
                    clearable
                  >
                    <el-option
                      v-for="item in options.calcSymbol"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="指标值">
                  <el-input
                    v-model="formData.indexRules[index].indexVal"
                    type="number"
                    placeholder="如果是百分比 如10%，请输入0.1"
                  ></el-input>
                </el-form-item>
              </el-card>
              <div class="card-remove">
                <i class="el-icon-remove" @click="removeIndexRule(index)"></i>
              </div>
            </div>
          </el-form-item>
          <el-form-item>
            <el-button plain icon="el-icon-plus" class="button_dashed" @click="newIndexRule">
              新增指标规则
            </el-button>
          </el-form-item>
        </template>
      </c-form>
      <div slot="footer">
        <el-button type="primary" @click="doSave">确 定</el-button>
        <el-button @click="doInit">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog title="拖拽设置多部位调度优先级" :visible.sync="partsPriority.show">
      <draggable v-model="partsPriority.data">
        <transition-group>
          <div
            class="card-item"
            v-for="(item, i) of partsPriority.data"
            :key="i"
            style="min-height:auto;background:#fff;cursor:move"
          >
            {{ i + 1 }}.{{ osg.codelabel('partsOne', item) }}
          </div>
        </transition-group>
      </draggable>
      <div slot="footer">
        <el-button type="primary" @click="partsPrioritySave">保 存</el-button>
        <el-button @click="partsPriority.show = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  activated() {
    window.$this = this;
  },
  name: 'scheduler',
  data() {
    window.$this = this;
    return {
      name: 'scheduler',
      fpi: { data: [] },
      searchValue: '',
      openDetail: false,
      extFields: [],
      formData: {
        conditions: [{ type: '', value: [] }],
        indexRules: [],
        schedulingPolicyObjectives: [],
        exts: {}
      },
      rules: this.$util.rules,
      options: {
        codecfg_regions: { codeId: 'regions' },
        codecfg_allotType: { codeId: 'ALLOTTYPE' },
        serviceTerritory: [],
        cascadeCode_repairParts: [],
        cascadeCode_channel: [],
        allScoreCalcRules: [],
        scoreCalcRules: [],
        codecfg_partsOne: { codeId: 'partsOne' },
        codecfg_calcSymbol: { codeId: 'calcSymbol' },
        partsOne: [],
        condScripts: [],
        allSR: [],
        SR: []
      },
      area: {
        options: this.osg.areaList,
        props: {
          checkStrictly: true,
          expandTrigger: 'hover'
        }
      },
      upload: {
        url: 'http://up-z1.qiniup.com',
        downloadUrl: this.osg.downloadUrl,
        data: {},
        dialogImageUrl: '',
        dialogVisible: false
      },
      // 多部位调度优先级
      partsPriority: {
        show: false,
        data: []
      },
      activeTab: ''
    };
  },
  mounted() {
    this.doInit();
    this.osg.getFields('scheduler', () => {
      this.osg.getFpi();
      this.getData();
      this.getScoreCalcRules('all');
      this.getGroovyScript();
      this.getAllSR();
    });
    this.getST();
  },
  methods: {
    pageSizeChange(pageSize) {
      this.fpi.rows = pageSize;
      this.getData();
    },
    pageChange(currentPage) {
      this.fpi.page = currentPage;
      this.getData();
    },
    doInit() {
      this.openDetail = false;
      this.formData = {
        conditions: [{ type: '', value: [] }],
        indexRules: [],
        schedulingPolicyObjectives: [],
        exts: {}
      };
    },
    getData() {
      let params = {
        page: this.fpi.page || 1,
        rows: this.fpi.rows || 20,
        'in:state|array-integer#and': '0,1',
        sortField: 'createTime',
        'regex:name|string#or': this.searchValue
      };
      window.$that.getParams(params);
      this.osg.setFpi(params);
      this.osg.ajax('basic/scheduler/query.do', params, res => {
        res.data.map(item => {
          item.exts = item.exts || {};
        });
        this.fpi = res;
        this.$nextTick(() => {
          this.$refs.table.doLayout();
          this.$forceUpdate();
        });
      });
    },
    doNew() {
      this.doInit();
      this.openDetail = true;
    },
    doEdit(row) {
      this.formData = this.$util.deepCopy(row);
      for (let condition of row.conditions) {
        this.getOptions(condition.type);
      }
      this.getScoreCalcRules();
      this.getSR('edit'); // 返显
      this.openDetail = true;
    },
    doSave() {
      if (this.osg.validate()) {
        for (let i = 0; i < this.formData.conditions.length; i++) {
          let condition = this.formData.conditions[i];
          if (condition.value.length == 0) {
            this.osg.alert('分单条件的值不能为空！');
            return;
          }
        }
        for (let i = 0; i < this.formData.indexRules.length; i++) {
          let indexRule = this.formData.indexRules[i];
          if (!indexRule.ruleId) {
            this.osg.alert('指标规则名称不能为空！');
            return;
          }
          if (!indexRule.calcSymbol) {
            this.osg.alert('指标规则条件不能为空！');
            return;
          }
          if (!indexRule.indexVal && indexRule.indexVal !== 0) {
            this.osg.alert('指标规则指标值不能为空！');
            return;
          }
          indexRule.indexVal =
            indexRule.indexVal || indexRule.indexVal === 0 ? String(indexRule.indexVal) : '';
        }
        this.osg.ajax('basic/scheduler/upsert.do', { data: JSON.stringify(this.formData) }, () => {
          this.osg.toast('保存成功');
          this.doInit();
          this.getData();
        });
      }
    },
    doEnable(id) {
      this.osg.ajax('basic/scheduler/enable.do', { id }, () => {
        this.osg.toast('启用成功');
        this.getData();
      });
    },
    doDisable(id) {
      this.osg.ajax('basic/scheduler/disable.do', { id }, () => {
        this.osg.toast('禁用成功');
        this.getData();
      });
    },
    doRemove(id) {
      this.osg.confirm('是否确认删除？', () => {
        this.osg.ajax('basic/scheduler/delete.do', { id }, () => {
          this.osg.toast('删除成功');
          this.getData();
        });
      });
    },
    //新增条件
    newCondition() {
      this.formData.conditions.push({
        type: '',
        value: ''
      });
    },
    //删除条件
    removeCondition(index) {
      if (this.formData.conditions[index].type == 'serviceType') {
        this.formData.conditions.splice(index, 1);
        this.getSR();
      } else {
        this.formData.conditions.splice(index, 1);
      }
    },
    //获取字典表
    getOptions(type) {
      let newType = type;
      if (type.endsWith('Inverse')) {
        type = type.substring(0, type.length - 7);
      }
      if (type != 'area' && type != 'serviceTerritory' && type != 'channel') {
        this.options['codecfg_' + newType] = {
          codeId: type.indexOf('exts.') != -1 ? type.split('.')[1] : type
        };
        this.osg.codeoption(() => {
          this.$forceUpdate();
        });
      }
    },
    //获取服务区域
    getST(query, type) {
      // 获取条件中已选中的服务类型，用来匹配对应服务类型的服务区域。
      let serviceType;
      let serviceTypeCondition = this.formData.conditions.filter(
        item => item.type == 'serviceType'
      );
      if (serviceTypeCondition.length > 0) {
        serviceType = serviceTypeCondition[0].value;
      }

      this.osg.ajax(
        'basic/serviceTerritoryCustom/query.do',
        {
          _all: '1',
          'in:state|array-integer#and': '1',
          'regex:name|string#or': query,
          'in:serviceType|array#and': serviceType && serviceType.join(),
          sortField: 'createTime',
          sortOrder: 'desc'
        },
        res => {
          res.data.map(item => {
            item.label = item.name;
            item.value = item._id;
          });
          this.options.serviceTerritory = res.data;
          // 当条件中的服务类型修改，将服务区域中不符合的值删除
          if (type == 'serviceTypeChange' && serviceType) {
            // 获取条件中服务区域的值
            let serviceTerritoryCondition = this.formData.conditions.filter(
              item => item.type == 'serviceTerritory'
            );
            // 获取条件中服务区域的值
            if (serviceTerritoryCondition.length > 0) {
              let serviceTerritory = serviceTerritoryCondition[0].value;
              // 服务区域不为空时
              if (serviceTerritory) {
                let sTValue = res.data.map(item => item.value);
                let newST = [];
                serviceTerritory.map(item => {
                  // 判断已选中值是否在选中服务类型返回的服务区域中
                  if (sTValue.indexOf(item) != -1) {
                    newST.push(item);
                  }
                });
                // 将服务区域中符合服务类型的值赋值回去
                serviceTerritoryCondition[0].value = newST;
              }
            }
          }
          this.$forceUpdate();
        }
      );
    },
    // 查询指标得分规则
    getScoreCalcRules(type) {
      if (type != 'all' && this.formData.regions.length == 0) {
        this.formData.schedulingPolicyObjectives = [];
        this.options.scoreCalcRules = [];
        return;
      }
      if (type == 'appointTypeChange') {
        this.formData.schedulingPolicyObjectives = [];
      }
      this.osg.ajax(
        'biz/scoreCalcRule/query.do',
        {
          _all: '1',
          'is:state|integer#and': 1,
          'in:regions|array#and': type == 'all' ? null : this.formData.regions.join(),
          'is:appointType|string#and': this.formData.appointType == 'partner' ? 'partner' : null,
          sortField: 'createTime',
          sortOrder: 'desc'
        },
        res => {
          res.data.map(item => {
            item.label = item.name;
            item.value = item._id;
          });
          if (type == 'all') {
            this.options.allScoreCalcRules = res.data;
          } else {
            this.options.scoreCalcRules = res.data;
          }
        }
      );
    },
    // 点击打开设置优先级弹窗
    partsPriorityClick() {
      let data = this.options.partsOne.map(item => item.value);
      this.getPartsPriority(data);
      this.partsPriority.show = true;
    },
    // 获取已设置过的优先级顺序，未设置过则使用部位一级字典
    getPartsPriority(data) {
      this.osg.ajax('/biz/tenantConfig/queryItem.do', { field: 'partsPriority' }, res => {
        if (res.data) {
          this.partsPriority.data = res.data.split(',');
        } else {
          this.partsPriority.data = data;
        }
      });
    },
    // 保存设置后的优先级
    partsPrioritySave() {
      this.osg.ajax(
        '/biz/tenantConfig/upsertItem.do',
        { field: 'partsPriority', data: this.partsPriority.data.join() },
        () => {
          this.partsPriority.show = false;
        }
      );
    },
    // 获取规则条件
    getGroovyScript() {
      this.osg.ajax(
        'groovyScript/query.do',
        {
          _all: '1',
          'is:type|integer#and': 9,
          'is:state|integer#and': 1
        },
        res => {
          res.data.map(item => {
            item.label = item.name;
            item.value = item._id;
          });
          this.options.condScripts = res.data;
        }
      );
    },
    getAllSR() {
      this.osg.ajax(
        'biz/serviceResource/query.do',
        {
          _all: '1',
          'is:state|integer#and': 1,
          sortField: 'createTime',
          sortOrder: 'desc'
        },
        res => {
          res.data.map(item => {
            item.label = item.name;
            item.value = item._id;
          });
          this.options.allSR = res.data;
        }
      );
    },
    getSR(type) {
      if (!this.formData.regions || this.formData.regions.length == 0 || !this.formData.appointType)
        return;
      let params = {
        _all: '1',
        'is:state|integer#and': 1,
        'is:resourceType|string#and': this.formData.appointType,
        'in:regions|array#and': this.formData.regions.join(),
        sortField: 'createTime',
        sortOrder: 'desc'
      };

      // 如果分单条件里选择了服务类型，则过滤对应类型的服务资源
      let serviceType = this.formData.conditions.filter(
        item => item.type == 'serviceType' && item.value && item.value.length > 0
      );
      params['in:serviceType|array#and'] = serviceType[0] ? serviceType[0].value.join() : null;

      this.osg.ajax('biz/serviceResource/query.do', params, res => {
        res.data.map(item => {
          item.label = item.name;
          item.value = item._id;
        });
        this.options.SR = res.data;
        if (this.formData.appointTypeIds && this.formData.appointTypeIds.length > 0) {
          if (this.options.SR.length == 0) {
            this.$set(this.formData, 'appointTypeIds', []);
          } else {
            // 编辑时不删除已选中的被过滤掉的服务资源，原服务资源id无法返现的表示不再复合条件，方便手动删除。
            if (type == 'edit') return;
            // 删除已选中的被过滤掉的服务资源
            let data = [];
            this.formData.appointTypeIds.map(id => {
              if (this.options.SR.find(item => item.value == id)) {
                data.push(id);
              }
            });
            this.$set(this.formData, 'appointTypeIds', data);
          }
        }
      });
    },
    // 变更行政区划
    regionsChange() {
      this.getScoreCalcRules();
      this.getSR();
    },
    // 变更指定分单类型 partner伙伴 technician技师
    appointTypeChange() {
      this.getScoreCalcRules('appointTypeChange');
      this.getSR();
    },
    // 变更分单条件-服务类型
    conditionValueChange(conditionType) {
      if (conditionType == 'serviceType') {
        this.getSR();
        this.getST(null, 'serviceTypeChange');
      }
    },
    //新增指标规则
    newIndexRule() {
      this.formData.indexRules.push({
        ruleId: '',
        calcSymbol: '',
        indexVal: ''
      });
    },
    //删除指标规则
    removeIndexRule(index) {
      this.formData.indexRules.splice(index, 1);
    }
  }
};
</script>
<style>
.condition-card {
  display: flex;
  justify-content: space-between;
}
.condition-card .el-card {
  width: 90% !important;
}
.condition-card .card-remove {
  width: 10%;
  text-align: center;
  color: #f2795b;
  cursor: pointer;
  font-size: 18px;
}
.automate .el-dialog__body {
  padding: 20px 30px;
}
.allot-rule .el-dialog__body {
  padding: 20px 30px !important;
}
</style>
